export default __webpack_public_path__ + "static/media/d88.d0e2f267.png";